angular.module("vgresiduos").component("jobAreaSelect", {
	controller: "JobAreaCtrl",
	templateUrl: "views/components/fields/jobAreaSelect/jobAreaSelect_template.html",
	bindings: {
		label: "@?",
		helpInfo: "@",
		emptyField: "<?",
		setterId: "<?",
		model: "=",
		isRequired: "<?",
		isDisabled: "<?",
		selectAutoWhenOneOption: "<?"
	}
});
